import { setSellerDocumentTypes } from './actions';
import { getResidentialUnitDocumentTypes } from '@/services/documents';

export const loadSellerDocumentTypes = async (dispatch, projectId) => {
    const data = await getResidentialUnitDocumentTypes(projectId);
    dispatch(setSellerDocumentTypes(data));
};